export default function TourFilters({
  categories,
  category,
  onCategoryChange,
  query,
  onQueryChange,
  availableOnly,
  onAvailableOnlyChange,
  resultCount,
  onReset,
}) {
  const hasFilters = Boolean(query || category !== "all" || availableOnly);

  return (
    <div className="rounded-[24px] bg-white p-4 shadow-lg md:rounded-[20px]" aria-label="Tour filters">
      <div className="flex items-center gap-3 md:flex-col md:items-stretch">
        <label className="relative flex-1">
          <span className="sr-only">Search tours</span>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="Search tours, places or themes"
            className="h-11 w-full rounded-xl border border-gray-200 bg-gray-50 px-4 text-[13px] text-gray-800 outline-none transition focus:border-[#E8876A] focus:ring-2 focus:ring-[#E8876A]/15"
          />
        </label>

        <label>
          <span className="sr-only">Tour category</span>
          <select
            value={category}
            onChange={(event) => onCategoryChange(event.target.value)}
            className="h-11 min-w-[170px] rounded-xl border border-gray-200 bg-white px-3 text-[13px] text-gray-700 outline-none transition focus:border-[#E8876A] focus:ring-2 focus:ring-[#E8876A]/15 md:w-full"
          >
            <option value="all">All categories</option>
            {categories.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
        </label>

        <label className="flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-xl border border-gray-200 px-3 text-[13px] text-gray-600">
          <input
            type="checkbox"
            checked={availableOnly}
            onChange={(event) => onAvailableOnlyChange(event.target.checked)}
            className="h-4 w-4 accent-[#E8876A]"
          />
          Seats available
        </label>

        {hasFilters && (
          <button type="button" onClick={onReset} className="h-11 border-0 bg-transparent px-2 text-[12px] font-medium text-gray-400 hover:text-[#E8876A] md:self-end">
            Reset
          </button>
        )}
      </div>
      <p className="mb-0 mt-3 text-[11px] text-gray-400 text-left" aria-live="polite">
        {resultCount} tour{resultCount === 1 ? "" : "s"} found
      </p>
    </div>
  );
}
